import CookieUtils from "./cookie-utils";
import PipEventObserver from "./pip-event-observer";
import ZipCodeStateLookup from "./zipcode-state-lookup";
import {moveAisleBay} from "./dom-adjuster";
let _model = null;
let _setDetails = null;
const urlParams = new URLSearchParams(window.location.search);
const debugValue = urlParams.get('debug');
const isDebugMode = debugValue && debugValue.toLowerCase() === 'true';

class PipModelAdapter {
	static deriveProps(data){
		let pickupDetails = getPickupDetails(data);
		let shippingDetails = getShippingDetails(data);
		let expressDetails = getExpressDetails(data);
		let fulfillmentDetails = getFulfillmentDetails(data, pickupDetails);

		//patch details based on full picture
		// TODO: put this in its proper place
		patchDetails(data, pickupDetails, fulfillmentDetails);

		/*
		copy this to help create data models we get from pip
		needs to be removed when live
		*/
		if(isDebugMode) {
			console.log("pip data model recieved:");
			console.log(JSON.stringify(data));
		}
		return {
			pickupDetails,
			shippingDetails,
			expressDetails,
			fulfillmentDetails
		}
	}

	static observeProps(model, setDetails, selectedOption, setSelectedOption){
		_model = model;
		_setDetails = setDetails;
		try{
			PipEventObserver.addToCart(model, setDetails);
			PipEventObserver.shippingZipChanged(model, setDetails, selectedOption, setSelectedOption);
			PipEventObserver.quantityError(model, setDetails, selectedOption, setSelectedOption);
			PipEventObserver.installationSelected(model, setDetails, selectedOption, setSelectedOption);
			PipEventObserver.proInstallationSelected(model, setDetails, selectedOption);
			!getIsGuest() && getInstantCheckoutModel(model, setDetails);
			getAisleBayInfo(model, setDetails);
		}catch(e){
			console.error(e);
		}
	}

	static getPickupDetailsForBossShared(model, isBossSharedQuantityError){
		let pickupDetails = model.pickupDetails;
		if(isBossSharedQuantityError){
			pickupDetails = {...pickupDetails, ...model.fulfillmentDetails.secondaryBuyOnlineShipToStore};
			pickupDetails.type = "BOSS";

			if(!pickupDetails.estimatedStartDeliveryDate && model.fulfillmentDetails.buyOnlineShipToStore){
				pickupDetails.estimatedStartDeliveryDate = model.fulfillmentDetails.buyOnlineShipToStore.estimatedStartDeliveryDate;
			}
			if(!pickupDetails.estimatedEndDeliveryDate && model.fulfillmentDetails.buyOnlineShipToStore){
				pickupDetails.estimatedEndDeliveryDate =  model.fulfillmentDetails.buyOnlineShipToStore.estimatedEndDeliveryDate
			}

			model.pickupDetails = pickupDetails;
			return  model.pickupDetails;
		}else{
			pickupDetails = {...pickupDetails, ...model.fulfillmentDetails.buyOnlinePickUpInStore};
			pickupDetails.type = "BOPIS";
			model.pickupDetails = pickupDetails;
			return  model.pickupDetails;
		}
	}
}

//TODO: These are explicit overrides to fix broken scenarios, these will be integrated
//		into a refactor of the fulfillment details derivation process.
function patchDetails(data, pickupDetails, fulfillmentDetails) {
	try{
		let isInStockNearby = data.inventory.nearbyStore && data.inventory.nearbyStore.isInStock;

		if(pickupDetails.type==="BOPIS"
			&& !pickupDetails.bossEligibleCatalog
			&& fulfillmentDetails.isOnlineOnlyItem
		){
			pickupDetails.type = "BOSS";
			pickupDetails.enabled = false;
		}

		if(pickupDetails.type==="BOPIS"
			&& !data.isB2BCustomer
			&& pickupDetails.bossEligibleCatalog
			&& pickupDetails.inventory.store.isLimitedQuantity
			&& !isInStockNearby
			&& fulfillmentDetails.isInStockAtOnline
			&& !doesBossExclusionApplies(data)
		){
			pickupDetails.type = "BOSS";
			pickupDetails.enabled = true;
			pickupDetails.available = true;
		}

		if(pickupDetails.type==="BOSS" 
			&& pickupDetails.bossEligibleCatalog 
			&& !pickupDetails.bossDominant
			&& pickupDetails.inventory.store.isLimitedQuantity
			&& !isInStockNearby
			// && fulfillmentDetails.isInStockAtOnline
		){
			pickupDetails.type = "BOPIS";
			pickupDetails.enabled = false;
			pickupDetails.available = false;
		}

		//Suppress bss for b2b based on flag
		if(pickupDetails.type==="BOPIS"
			&& fulfillmentDetails.isBossBopisSharedTile
			&& data.isB2BCustomer 
		){
			fulfillmentDetails.isBossBopisSharedTile = false;
			pickupDetails.isSharedItem = false;
		}

		if(pickupDetails.type==="BOPIS" &&
			fulfillmentDetails.isStoreAssortmentRestricted
		){
			pickupDetails.enabled = false;
			pickupDetails.available = false;
		}
	}catch(e){
		console.error(e);
	}
}

function getPickupDetails(data){
	let pickupDetails = {enabled: false};
	let { products, fulfillment, inventory, nearbyStore } = data;
	let { primary } = products;
	try{
		if(products && primary && primary.data){
			pickupDetails.itemId = primary.data.itemId;
			//get catalog values
			if(primary.data.attributeGroups) {
				pickupDetails.attributeGroups = primary.data.attributeGroups;
				if (pickupDetails.attributeGroups.length > 0) {
					//for notDisplayed
					getNotDisplayedEntriesUsed(pickupDetails);
					if(pickupDetails.notDisplayedEntriesUsed && pickupDetails.notDisplayedEntriesUsed.length > 0) {
						let bossDominantEntry = pickupDetails.notDisplayedEntriesUsed.filter(entries => entries.name === "BOSS Dominant");
						pickupDetails.bossDominant = (bossDominantEntry.length > 0 && (bossDominantEntry[0].value==="true" || bossDominantEntry[0].value===true)) || false;
						let bossEligibleEntry = pickupDetails.notDisplayedEntriesUsed.filter(entries => entries.name === "BOSS eligible");
						pickupDetails.bossEligibleCatalog = (bossEligibleEntry.length > 0 && (bossEligibleEntry[0].value==="true" || bossEligibleEntry[0].value===true)) || false;
					}
				}
			}
			if(primary.data.itemExtension){
				if(primary.data.itemExtension.bossDominant) {
					pickupDetails.bossDominant = pickupDetails.bossDominant && primary.data.itemExtension.bossDominant;
				}
				pickupDetails.isSharedItem = primary.data.itemExtension.sharedItem;
			}
			if(primary.data.aisleBay) {
				pickupDetails.aisle = primary.data.aisleBay.aisle;
				pickupDetails.bay = primary.data.aisleBay.bay;
				window._aisleBay_cache = primary.data.aisleBay
			}
		}

		//local store data not inventory
		const localStore = data.customer?data.customer.localStore:data.localStore;
		if(localStore) {
			pickupDetails.store = localStore;
		}
		//nearby store data not inventory
		if(nearbyStore) {
			pickupDetails.nearbyStore = nearbyStore;
		}

		//inventory data
		if(inventory){
			pickupDetails.inventory = inventory;
			if(inventory.online) {
				pickupDetails.isOutOfStock = inventory.online.isOutOfStock;
				if (inventory.online.isBackordered) {
					pickupDetails.isBackordered = inventory.online.isBackordered;
				}
				if (inventory.online.backorderExpectedShipDate) {
					pickupDetails.backorderExpectedShipDate = inventory.online.backorderExpectedShipDate;
				}
			}
			if(inventory.store) {
				pickupDetails.store.quantity = inventory.store.quantity;
				pickupDetails.isLocalStoreOutOfStock = inventory.store.isOutOfStock || inventory.store.isUnavailable;
			}
			if(inventory.nearbyStore){
				pickupDetails.nearbyStore.quantity = inventory.nearbyStore.quantity;
				pickupDetails.isNearbyStoreInStock = inventory.nearbyStore.isInStock;
			}
			pickupDetails.isPickupInStoreNearby = pickupDetails.isSharedItem && pickupDetails.isLocalStoreOutOfStock && pickupDetails.isNearbyStoreInStock;
		}

		if(fulfillment){
			pickupDetails.enabled = inventory && pickupDetails.isPickupInStoreNearby;
			if(fulfillment.store) {
				if(fulfillment.store.buyOnlinePickUpInStore || fulfillment.store.buyOnlineShipToStore) {
					if (doesBossExclusionApplies(data) && fulfillment.store.buyOnlineShipToStore) {
						pickupDetails.enabled = false;
						pickupDetails.bossShippingExclusionApplies = true;
						pickupDetails.type = "BOSS";
					} else {
						pickupDetails.enabled = true;
					}

          			pickupDetails.secondaryBuyOnlineShipToStore = !!fulfillment.store.secondaryBuyOnlineShipToStore;


					if(fulfillment.store.buyOnlinePickUpInStore) {
						pickupDetails.type = "BOPIS";
						pickupDetails = {...pickupDetails, ...fulfillment.store.buyOnlinePickUpInStore};
					} else if (pickupDetails.isPickupInStoreNearby) {
						pickupDetails.type = "BOPIS";
					} else if(fulfillment.store.buyOnlineShipToStore && !doesBossExclusionApplies(data)){
						pickupDetails.type = "BOSS";
						pickupDetails = {...pickupDetails, ...fulfillment.store.buyOnlineShipToStore};
					}
				}
			}
			if(fulfillment.isPurchasableInLocalStoreInStock || fulfillment.isZeroStockInLocalStoreActive){
				pickupDetails.enabled = false;
				pickupDetails.type = "BOPIS";
				pickupDetails.isPurchasableInLocalStoreInStock = fulfillment.isPurchasableInLocalStoreInStock;
				pickupDetails.isZeroStockInLocalStoreActive = fulfillment.isZeroStockInLocalStoreActive;
			}
			if(
				!data.isB2BCustomer 
				&& !pickupDetails.bossShippingExclusionApplies
				&& (fulfillment.isPurchasableInLocalStoreBoss ||
				fulfillment.isZeroStockInLocalStoreBoss ||
					(
						!pickupDetails.enabled
						&& pickupDetails.bossEligibleCatalog
						&& pickupDetails.bossDominant
						&& fulfillment.BossEstimatedShippingStartDate
					))
				){
				pickupDetails.enabled = true;
				pickupDetails.type = "BOSS";
				pickupDetails.isZeroStockInLocalStoreBoss = fulfillment.isZeroStockInLocalStoreBoss;
				pickupDetails.isPurchasableInLocalStoreBoss = true;//fulfillment.isPurchasableInLocalStoreBoss;
				pickupDetails.bossEstimatedShippingStartDate = fulfillment.BossEstimatedShippingStartDate;
				pickupDetails.bossEstimatedShippingEndDate = fulfillment.BossEstimatedShippingEndDate;
			}
		}

		if(!data.isB2BCustomer 
				&& pickupDetails.bossDominant){
			pickupDetails = {...pickupDetails, ...setBOSSSharedSKUTileType(data, pickupDetails)};
		}

		pickupDetails.available = pickupDetails.enabled?isAvailable(pickupDetails):false;
		pickupDetails.enabled = pickupDetails.enabled && pickupDetails.available;

		if(shouldUseNearby(pickupDetails, data)){
			pickupDetails.useNearby = true;
		}
		pickupDetails.attributeGroups = null;
		pickupDetails.limitedStockInventoryRestricted =
			pickupDetails.isInventoryRestricted &&
			pickupDetails.inventory &&
			pickupDetails.inventory.store &&
			pickupDetails.inventory.store.isLimitedQuantity &&
			!pickupDetails.isAlphaPromptRestricted;
		}catch(e){
		console.error(e);
	}
	if(pickupDetails.type === null || pickupDetails.type === undefined){
		pickupDetails.type = "BOPIS";
	}
	return pickupDetails;
}

function setBOSSSharedSKUTileType(data, pickupDetails){
	let isLimitedQuantityInLocalStore = data.inventory && data.inventory.store && data.inventory.store.isLimitedQuantity;
	let isOutOfStockInLocalStore = data.inventory && data.inventory.store && (data.inventory.store.isOutOfStock || data.inventory.store.isUnavailable);
	let isInStockNearby = data.inventory.nearbyStore && data.inventory.nearbyStore.isInStock;
	let isLimitedStockNearby = data.inventory.nearbyStore && data.inventory.nearbyStore.isLimitedQuantity;
	let isInStockOnline = data.inventory.online && (data.inventory.online.inStock || data.inventory.online.isBackordered);
	if(isLimitedQuantityInLocalStore || (isOutOfStockInLocalStore && isLimitedStockNearby)){
		pickupDetails.enabled = true;
		pickupDetails.type = (pickupDetails.bossEligibleCatalog && isInStockOnline) ? "BOSS" : "BOPIS";
		if(data.fulfillment &&
			data.fulfillment.store &&
			data.fulfillment.store.secondaryBuyOnlineShipToStore){
			pickupDetails = {...pickupDetails, ...data.fulfillment.store.secondaryBuyOnlineShipToStore};
		}
	}if(isOutOfStockInLocalStore && (isInStockNearby || isLimitedStockNearby)){
		pickupDetails.enabled = true;
		pickupDetails.type = "BOPIS";
	}
	if(isOutOfStockInLocalStore && !data.inventory.nearbyStore && isInStockOnline) {
		pickupDetails.enabled = true;
		pickupDetails.type = "BOSS";
	}
	return pickupDetails;
}

function getShippingDetails(data){
	let shippingDetails = {enabled: false};
	try{
		let options = data.fulfillment;
		if(options && options.shipping && options.shipping.shipToHome){
			shippingDetails.enabled = true;

			if(options.shipping.shipToHome.hasFreeShipping){
				shippingDetails.hasFreeShipping = options.shipping.shipToHome.hasFreeShipping;
			}
			if(options.shipping.shipToHome.freeShippingThreshhold){
				shippingDetails.freeShippingThreshhold = options.shipping.shipToHome.freeShippingThreshhold;
			}
			// if(!options.shipping.shipToHome.dynamicEta){
			if(options.shipping.shipToHome.estimatedShippingStartDate && options.shipping.shipToHome.estimatedDeliveryDate){
				shippingDetails.estimatedDeliveryDate = options.shipping.shipToHome.estimatedDeliveryDate;
			}
			// }
			shippingDetails.rawEstimatedShippingStartDate = options.shipping.shipToHome.rawEstimatedShippingStartDate;
			shippingDetails.estimatedShippingStartDate = options.shipping.shipToHome.estimatedShippingStartDate;
			shippingDetails.estimatedShippingEndDate = options.shipping.shipToHome.estimatedShippingEndDate;
			if(options.shipping.shipToHome.dynamicEtaOptimalDate){
				shippingDetails.dynamicEtaOptimalDate = options.shipping.shipToHome.dynamicEtaOptimalDate;
			}
			if(options.shipping.shipToHome.dynamicEta){
				shippingDetails.dynamicEta = options.shipping.shipToHome.dynamicEta;
			}
			if(data.inventory.online.isOutOfStock){
				shippingDetails.isOutOfStock = data.inventory.online.isOutOfStock;
			}
			if(data.inventory.online.isBackordered){
				shippingDetails.isBackordered = data.inventory.online.isBackordered;
			}
			if(data.inventory.online.backorderExpectedShipDate){
				shippingDetails.backorderExpectedShipDate = data.inventory.online.backorderExpectedShipDate;
			}

		}
		const localStore = data.customer?data.customer.localStore:data.localStore;
		if(localStore && localStore.zipCode){
			shippingDetails.localStoreZipCode = localStore.zipCode;
		}

		try{
			const detaZip = CookieUtils.getCookie("DETA_ZIP");
			const deliveryZip = CookieUtils.getCookie("DELIVERY_ZIP");
			if(detaZip || deliveryZip){
				shippingDetails.sthZipCode = detaZip || deliveryZip;
				shippingDetails.sthState = ZipCodeStateLookup.getState(shippingDetails.sthZipCode);
			}

			if(data.shippingExclusion &&
				data.shippingExclusion.exclusionLocations &&
				shippingDetails.sthState &&
				doesSthExclusionApplies(data.shippingExclusion.exclusionLocations, shippingDetails.sthState))
			{
					shippingDetails.enabled = false;
					shippingDetails.sthShippingExclusionApplies = true;
					// if (data.customer && data.customer.localStore && data.customer.localStore.statecode) {
					// shippingDetails.localStoreState = data.customer.localStore.statecode;
					// }
			}


		}catch(e){
			console.error(e);
		}

	}catch(e){
		console.error(e);
	}
	return shippingDetails;
}

function getExpressDetails(data){
	let expressDetails = {enabled: false};
	try{
		let options = data.fulfillment;
		if(options && options.shipping && options.shipping.buyOnlineDeliverFromStore){
			expressDetails.enabled = true;
			expressDetails.zipCode = data.customer?data.customer.dynamicEtaZipCode:"";
			expressDetails = {...expressDetails, ...options.shipping.buyOnlineDeliverFromStore};
		}
	}catch(e){
		console.error(e);
	}
	return expressDetails;
}


/*
gathers shared flags for all tile.
at the end of the function, I am creating custom flags that go with the story.
*/

function getFulfillmentDetails(data, pickupDetails){
	let fulfillmentDetails = {
		storeQuantity: 0,
		storeName: "",
		isGuest: getIsGuest(),
		isB2CCustomer: isCustomerB2C(),
		bodfsEligible: false,
		bopisEligible: false,
		bossEligible: false
	};
	try{
		//inventory
		let {
			inventory,
			fulfillment,
			customer,
			products,
			pipCheckoutOptions,
			features,
			shippingExclusion,
			inStoreAssemblyAvailable,
            subscribeAndSaveEligible,
		} = data;
		let {primary} = products;

		//root pip model
		fulfillmentDetails.inStoreAssemblyAvailable = inStoreAssemblyAvailable;
        if(subscribeAndSaveEligible){
            fulfillmentDetails.subscribeAndSaveEligible = subscribeAndSaveEligible;
        }

        fulfillmentDetails.isSubscriptionEligible = isSubscriptionEligible(subscribeAndSaveEligible, features, fulfillment, products);

		//pipCheckoutOptions
		if(pipCheckoutOptions){
			fulfillmentDetails.isPayPalAvailable = pipCheckoutOptions.isPayPalAvailable;
		}

		fulfillmentDetails.showBopisCovidAlert = determineBopisCovidAlert(features);
		fulfillmentDetails.showBodfsCovidAlert = true;
		//features flags
		if(features){
			if(features.payPalPaymentOptionEnabled){
				fulfillmentDetails.payPalPaymentOptionEnabled = features.payPalPaymentOptionEnabled;
			}
			if(features.pipBopisCovidMessageOff){
				fulfillmentDetails.showBopisCovidAlert = false;
			}
			if(features.pipBodfsCovidMessageOff){
				fulfillmentDetails.showBodfsCovidAlert = false;
			}
		}

		//shippingExclusion
		if(shippingExclusion){
			fulfillmentDetails.shippingExclusion = shippingExclusion;
		}

		//customer
		if (customer) {
			getCustomerInfo(fulfillmentDetails,customer);
		}

		//primary data
		if(products && primary && primary.data) {
			getPrimaryData(fulfillmentDetails,primary.data, pickupDetails, inventory);
		}

		if (inventory) {
			getInventoryFlags(fulfillmentDetails,inventory);
		}

		//fulfillment
		if(fulfillment) {
			fulfillmentFlags(fulfillmentDetails,fulfillment, pickupDetails)
		}

		//notifyMe
		//todo: move to getShippingDetails
		fulfillmentDetails.sthNotAvailable =
			fulfillmentDetails.isOosAtOnline &&
			fulfillmentDetails.isItemBopisAtStore;

		//todo: can be simplified?
		if(isInstantCheckoutEligible(data)){
			fulfillmentDetails.isInstantCheckoutEligible=true;
		}

		//todo: can be simplified?
		if(isNonMajorAppliance(data)){
			fulfillmentDetails.isNonMajorAppliance = true;
		}

		//attributeGroups set to null so it won't show on snapshot
		fulfillmentDetails.attributeGroups = null;

		fulfillmentDetails.emptyCart = isCartEmpty();

		fulfillmentDetails.isSubscriptionEligible =
			isSubscriptionEligible(data.subscribeAndSaveEligible, features, fulfillment, products);

		fulfillmentDetails.bossNotAvailable =
			((fulfillmentDetails.storeStatusCode === "400")
				&& (fulfillmentDetails.availabilityType === "Browse Only" || fulfillmentDetails.availabilityType === "Shared")
				&& !fulfillmentDetails.bopisEligible
				&& !fulfillmentDetails.bossEligible
				&& fulfillmentDetails.isOosAtOnline);

		notifyBoxFlags(fulfillmentDetails, pickupDetails);

	}catch(e){
		console.error(e);
	}
	return fulfillmentDetails;
}

function determineBopisCovidAlert(features){
	try{
		let isGreaterThan2PM =
			(new Date().getHours() >= 14) ||
				(features && features.itsAfter2pmSomewhere);
		return isGreaterThan2PM;
	}catch(e){
		console.error(e);
	}
}

function isCartEmpty(){
	let isEmpty = true;
	try{
	    let count = CookieUtils.getCartCount();
    	isEmpty = (count === 0 || count === "0" || count === "");
	}catch(e){
		console.error(e);
	}
	return isEmpty;
}

function getCustomerInfo(fulfillmentDetails, customer) {
	if (customer.localStore) {
		fulfillmentDetails.storeName = customer.localStore.storeName;
		// fulfillmentDetails.bodfsEligible = customer.localStore.bodfsEligibilityFlag === "Y";
		// fulfillmentDetails.bossEligible = customer.localStore.bossElgFlg === "Y";
		// fulfillmentDetails.bopisEligible = customer.localStore.bopisElgFlg === "Y";
	}
	return fulfillmentDetails;
}

function getPrimaryData(fulfillmentDetails, primaryData, pickupDetails={}, inventory={}) {
	let {
		availabilityType,
		attributeGroups,
		itemExtension,
		info,
		aisleBay,
		storeSkus,
    itemAvailability
	} = primaryData;

	const onlineOnly = "Online";
	const shared = "Shared";
	const browseOnly = "Browse Only";

	fulfillmentDetails.availabilityType = availabilityType;
	fulfillmentDetails.attributeGroups = attributeGroups;

  if(itemAvailability && itemAvailability.discontinuedItem) {
    fulfillmentDetails.discontinuedItem = true;
  }

	if(itemExtension) {
		fulfillmentDetails.isOnlineOnlyItem = itemExtension.onlineOnlyItem && availabilityType === onlineOnly;
		fulfillmentDetails.isSharedOnlyItem = itemExtension.sharedItem && availabilityType === shared;
		fulfillmentDetails.isBrowseOnlyItem = itemExtension.browseOnlyItem && availabilityType === browseOnly;
		if(itemExtension.buyOnlineDeliverFromStoreProductApiFulfillmentOption ){
			fulfillmentDetails.bodfsEligibleStatus = itemExtension.buyOnlineDeliverFromStoreProductApiFulfillmentOption.status;
		}
	}
	if (info) {
		fulfillmentDetails.productDepartment = info.productDepartment ? info.productDepartment  : "";
		fulfillmentDetails.className = info.classNumber ? info.classNumber : "";
		fulfillmentDetails.isLiveGood = isLiveGood(info);
		if(fulfillmentDetails.isLiveGood){
			fulfillmentDetails.isInSeason = isInSeason(info);
		}
	}
	if (storeSkus && storeSkus.length > 0) {
		fulfillmentDetails.storeStatus = storeSkus[0].storeStatus;
		fulfillmentDetails.storeStatusType = storeSkus[0].storeStatusType;
		fulfillmentDetails.storeStatusCode =
			checkStatusType(fulfillmentDetails,fulfillmentDetails.storeStatusType);
		fulfillmentDetails.onlineStatus = storeSkus[1].storeStatus;
		fulfillmentDetails.onlineStatusType = storeSkus[1].storeStatusType;
		fulfillmentDetails.onlineStatusCode =
			checkStatusType(fulfillmentDetails,fulfillmentDetails.onlineStatusType);
	}
	if (aisleBay) {
		fulfillmentDetails.aisle = aisleBay.aisle;
		fulfillmentDetails.bay = aisleBay.bay;
		window._aisleBay_cache = aisleBay;
	}
	//get catalog values
	if (attributeGroups && attributeGroups.length > 0){
		//for notDisplayed
		fulfillmentDetails.notDisplayedEntriesUsed = getNotDisplayedEntriesUsed(fulfillmentDetails);
		if(fulfillmentDetails.notDisplayedEntriesUsed && fulfillmentDetails.notDisplayedEntriesUsed.length > 0) {
			let bossDominantEntry = fulfillmentDetails.notDisplayedEntriesUsed.filter(entries => entries.name === "BOSS Dominant");
			fulfillmentDetails.bossDominant = (bossDominantEntry.length > 0 && (bossDominantEntry[0].value==="true" || bossDominantEntry[0].value===true)) || false;
			let bossEligibleEntry = fulfillmentDetails.notDisplayedEntriesUsed.filter(entries => entries.name === "BOSS eligible");
			fulfillmentDetails.bossEligibleCatalog = (bossEligibleEntry.length > 0 && (bossEligibleEntry[0].value==="true" || bossEligibleEntry[0].value===true)) || false;
		}
		if(fulfillmentDetails.bossDominant && fulfillmentDetails.bossEligibleCatalog) {
			if(
				!pickupDetails.useNearby
				&& !isOutOfStockOnlineLimitedInStore(inventory, pickupDetails)
				&& !inventory.online.isOutOfStock
			){
				fulfillmentDetails.isBossBopisSharedTile = fulfillmentDetails.isSharedOnlyItem;
			}

		}
	}
	return fulfillmentDetails
}

function isOutOfStockOnlineLimitedInStore(inventory) {
	let itIs = false;
	try{
		if(inventory.online
			&& inventory.store
			&& inventory.online.isOutOfStock
			&& inventory.store.isLimitedQuantity
		){
			itIs = true;
		}
	}catch(e){
		console.error(e);
	}
	return itIs;
}

function checkStatusType(fulfillmentDetails, statusType) {
	let statusTypeCode = '0';
	switch (statusType) {
		case 'ACTIVE': statusTypeCode = '100';
			break;
		case 'IN SEASON': statusTypeCode = '200';
			break;
		case 'OUT OF SEASON': statusTypeCode = '300';
			break;
		case 'INACTIVE': statusTypeCode = '400';
			break;
		case 'CLEARANCE': statusTypeCode = '500';
			break;
		case 'DELETED': statusTypeCode = '600';
			break;
		case 'NA':
		default: statusTypeCode = '0';
	}
	return statusTypeCode;
}

function getInventoryFlags(fulfillmentDetails, inventory) {
	let {online, store, nearbyStore} = inventory;
	//online inventory
	if(online) {
		fulfillmentDetails.onlineInventory = online;
		fulfillmentDetails.isOosAtOnline = online.isOutOfStock;
		fulfillmentDetails.isUnavailableAtOnline = online.isUnavailable;
		fulfillmentDetails.isInStockAtOnline = online.isInStock;
		fulfillmentDetails.isBackordered = online.isBackordered;
		fulfillmentDetails.onlineQuantity = online.quantity;
	}

	//store inventory
	if(store) {
		fulfillmentDetails.storeInventory = store;
		fulfillmentDetails.isOosAtStore = store.isOutOfStock;
		fulfillmentDetails.isUnavailableAtStore = store.isUnavailable;
		fulfillmentDetails.isInStockAtStore = store.isInStock;
		fulfillmentDetails.isItemBopisAtStore =
			fulfillmentDetails.bopisEligible &&
			fulfillmentDetails.isInStockAtStore;
		fulfillmentDetails.storeQuantity = store.quantity;
	}

	//nearby store inventory
	if (nearbyStore) {
		fulfillmentDetails.nearbyInventory = nearbyStore;
		fulfillmentDetails.isOosAtNearbyStore = nearbyStore.isOutOfStock;
		fulfillmentDetails.isUnavailableAtNearbyStore = nearbyStore.isUnavailable;
		fulfillmentDetails.isInStockAtNearbyStore = nearbyStore.isInStock;
		if(inventory.nearbyStore) {
			fulfillmentDetails.nearbyStoreQuantity = inventory.nearbyStore.quantity;
		}
	}
	return fulfillmentDetails;
}

function fulfillmentFlags(fulfillmentDetails, fulfillment, pickupDetails) {
	let {fulfillable, store, shipping} = fulfillment;
	fulfillmentDetails.fulfillable = fulfillable;
	fulfillmentDetails.isPurchasableInLocalStoreInStock = fulfillment.isPurchasableInLocalStoreInStock;
	fulfillmentDetails.isZeroStockInLocalStoreActive = fulfillment.isZeroStockInLocalStoreActive;
	fulfillmentDetails.isZeroStockInLocalStoreBoss = fulfillment.isZeroStockInLocalStoreBoss;
	fulfillmentDetails.isPurchasableInLocalStoreBoss = fulfillment.isPurchasableInLocalStoreBoss;
	fulfillmentDetails.pickupType = pickupDetails.type;
	if (store) {
		fulfillmentDetails.isPurchasedInStoreOnly = store.purchasedInStoreOnly;
		if(store.buyOnlineShipToStore){
			fulfillmentDetails.buyOnlineShipToStore = store.buyOnlineShipToStore;
			fulfillmentDetails.bossEligible = pickupDetails.type === "BOSS";
		}
		if(store.buyOnlinePickUpInStore){
			fulfillmentDetails.buyOnlinePickUpInStore = store.buyOnlinePickUpInStore;
			fulfillmentDetails.isStoreAssortmentRestricted = store.buyOnlinePickUpInStore.isStoreAssortmentRestricted;
			fulfillmentDetails.bopisEligible = true;
		}
		if(store.secondaryBuyOnlineShipToStore){
			fulfillmentDetails.secondaryBuyOnlineShipToStore = store.secondaryBuyOnlineShipToStore;
		}
	}

	//online fulfillments
	if(shipping) {
		if(shipping.buyOnlineDeliverFromStore) {
			fulfillmentDetails.buyOnlineDeliverFromStore = shipping.buyOnlineDeliverFromStore;
			fulfillmentDetails.bodfsEligible = true;
			fulfillmentDetails.isAssemblyEligible = shipping.buyOnlineDeliverFromStore.isAssemblyEligible || false;
		}
	}

	return fulfillmentDetails;
}

function isLiveGood(info){
	return info.productDepartment && info.productDepartment === "28" && info.classNumber && info.classNumber === "8";
}

function isInSeason(info){
	return info.seasonStatusEligible;
}

function notifyBoxFlags(fulfillmentDetails, pickupDetails) {

	//to enable notify me in general
	fulfillmentDetails.doNotifyMe =
		fulfillmentDetails.isOosAtOnline &&
		fulfillmentDetails.isUnavailableAtStore;

	//to enable notify me for share out of stock skus
	fulfillmentDetails.doNotifyMeOosSharedOnly =
		!fulfillmentDetails.isPurchasableInLocalStoreInStock &&
		!fulfillmentDetails.isZeroStockInLocalStoreActive &&
		!fulfillmentDetails.isPurchasableInLocalStoreBoss &&
		fulfillmentDetails.isSharedOnlyItem &&
		(fulfillmentDetails.isOosAtStore || fulfillmentDetails.isUnavailableAtStore ) &&
		(fulfillmentDetails.nearbyInventory ?
			(fulfillmentDetails.isOosAtNearbyStore ||
			fulfillmentDetails.isUnavailableAtNearbyStore ||
			fulfillmentDetails.isLimitedQuantityNearbyStore) : true) &&
		(fulfillmentDetails.bodfsEligible ?
			!fulfillmentDetails.bodfsEligibleStatus : true) &&
		fulfillmentDetails.isOosAtOnline  &&
		!fulfillmentDetails.isBackordered
		&& fulfillmentDetails.bossNotAvailable;

	//to enable notify me for store only out of stock skus
	fulfillmentDetails.doNotifyMeOosStoreOnly =
		!fulfillmentDetails.isPurchasableInLocalStoreInStock &&
		!fulfillmentDetails.isZeroStockInLocalStoreActive &&
		!fulfillmentDetails.isZeroStockInLocalStoreBoss &&
		fulfillmentDetails.isBrowseOnlyItem && (
			(!fulfillmentDetails.bopisEligible && ((
				(fulfillmentDetails.storeStatusCode === "300" ||
				fulfillmentDetails.storeStatusCode === "400" ||
				fulfillmentDetails.storeStatusCode === "500" ||
				fulfillmentDetails.storeStatusCode === "600") &&
				(fulfillmentDetails.isOosAtStore || fulfillmentDetails.isUnavailableAtStore ))||
				(((fulfillmentDetails.storeStatusCode === "500" ||
				fulfillmentDetails.storeStatusCode === "600") &&
				fulfillmentDetails.isInStockAtStore)))) ||
			(fulfillmentDetails.storeStatusCode === "500" || fulfillmentDetails.storeStatusCode === "600") || (
				(fulfillmentDetails.bopisEligible && (fulfillmentDetails.isOosAtStore || fulfillmentDetails.isUnavailableAtStore)) &&
				(fulfillmentDetails.bodfsEligible ?
					!fulfillmentDetails.bodfsEligibleStatus :
					(fulfillmentDetails.nearbyInventory ?
						fulfillmentDetails.isOosAtNearbyStore :
						true))));

	//to enable notify me for online only out of stock skus
	fulfillmentDetails.doNotifyMeOosOnlineOnly =
		fulfillmentDetails.isOnlineOnlyItem &&
		fulfillmentDetails.isOosAtOnline;

	//used to make other components to hide, so only notify me shows up
  // TODO: Actually this is summarily false^. when true, we show everything.
  // seeing as this is basically shouldShowStuff, we should name the function as such.
	fulfillmentDetails.doHideForNotifyMe =
		!fulfillmentDetails.doNotifyMe &&
		!fulfillmentDetails.doNotifyMeOosSharedOnly &&
		!fulfillmentDetails.doNotifyMeOosStoreOnly &&
		!fulfillmentDetails.doNotifyMeOosOnlineOnly &&
    	!fulfillmentDetails.discontinuedItem;

	//used to make notify me show
	fulfillmentDetails.showNotifyBox =
		(fulfillmentDetails.doNotifyMe ||
		fulfillmentDetails.doNotifyMeOosSharedOnly ||
		fulfillmentDetails.doNotifyMeOosStoreOnly ||
		fulfillmentDetails.doNotifyMeOosOnlineOnly) &&
		!pickupDetails.limitedStockInventoryRestricted &&
		!fulfillmentDetails.discontinuedItem;

	//handle case where notify me box is showing even though inventory is
	//avail. in nearby store. Need to investigate what flag is causing this
	overrideNotifyMeFlagsForNeabyAvailable(fulfillmentDetails, pickupDetails);

	return fulfillmentDetails;
}


function overrideNotifyMeFlagsForNeabyAvailable(fulfillmentDetails, pickupDetails){
	try{
		const {doHideForNotifyMe, showNotifyBox} = fulfillmentDetails;
		if(!fulfillmentDetails.doHideForNotifyMe && fulfillmentDetails.showNotifyBox){
			if(pickupDetails.enabled && pickupDetails.isNearbyStoreInStock){
				fulfillmentDetails.doHideForNotifyMe = true;
				fulfillmentDetails.showNotifyBox = false;
			}
		}
	}catch(e){
		console.error(e);
	}
}

function  getNotDisplayedEntriesUsed(details) {
	//for notDisplayed
	let notDisplayedEntries = details.attributeGroups.filter(groups => groups.groupType === "notDisplayed")[0].entries;
	details.notDisplayedEntriesUsed = [];
	let thdBrowseOnlinestatusAtribute = null;
	let thdInStoreAtribute = null;
	let thdInMarket401Atribute = null;
	let bossDominateAtribute = null;
	let bossEligibleAttribute = null;
	if (notDisplayedEntries) {
		//store only - THD Browse Onlinestatus
		thdBrowseOnlinestatusAtribute = notDisplayedEntries.filter( entries => entries.name === "THD Browse Onlinestatus");
		if(thdBrowseOnlinestatusAtribute[0] !== undefined) {
			details.notDisplayedEntriesUsed.push(thdBrowseOnlinestatusAtribute[0]);
		}

		//boss shared skus = BOSS Dominate
		thdInStoreAtribute = notDisplayedEntries.filter( entries => entries.name === "THD_IN_STORE");
		if(thdInStoreAtribute[0] !== undefined) {
			details.notDisplayedEntriesUsed.push(thdInStoreAtribute[0]);
		}

		//boss shared skus = BOSS Dominate
		thdInMarket401Atribute = notDisplayedEntries.filter( entries => entries.name === "THD_IN_MARKET_401");
		if(thdInMarket401Atribute[0] !== undefined) {
			details.notDisplayedEntriesUsed.push(thdInMarket401Atribute[0]);
		}

		//boss shared skus = BOSS Dominate
		bossDominateAtribute = notDisplayedEntries.filter( entries => entries.name === "BOSS Dominant");
		if(bossDominateAtribute[0] !== undefined) {
			details.notDisplayedEntriesUsed.push(bossDominateAtribute[0]);
		}

		//boss shared skus = BOSS Eligible
		bossEligibleAttribute = notDisplayedEntries.filter( entries => entries.name === "BOSS eligible");
		if(bossEligibleAttribute[0] !== undefined) {
			details.notDisplayedEntriesUsed.push(bossEligibleAttribute[0]);
		}

	}
	return details.notDisplayedEntriesUsed;
}

function isSubscriptionEligible(subscribeAndSaveEligible, features, fulfillment, products){
    return !!(subscribeAndSaveEligible
		&& features.subscribeAndSaveFeature.isEnabled
		&& fulfillment
		&& fulfillment.shipping
		&& fulfillment.shipping.shipToHome
		&& products
		&& products.primary
		&& products.primary.data
		&& products.primary.data.itemExtension
		&& products.primary.data.itemExtension.pricing
		&& (products.primary.data.itemExtension.pricing.originalPrice
			|| products.primary.data.itemExtension.pricing.specialPrice));
}

function getIsGuest(){
	let isGuest = true;
	try{
		if(CookieUtils.getCookie("THD_USER") ||
			CookieUtils.getCookie("THD_CUSTOMER")){
			isGuest = false;
		}
	}catch(e){
		console.error(e);
	}
	return isGuest;
}

const isCustomerB2C = () => !getIsGuest() && (!!CookieUtils.getCookie("THD_USER"));

function isAvailable(details){
	let isAvailable = true;
	try{
		if(details.type==="BOPIS"){
			let quantity = details.inventory? (details.inventory.store? details.inventory.store.quantity:0) :0;
			if(quantity===0){
				let nearbyQuantity = details.inventory? (details.inventory.nearbyStore?details.inventory.nearbyStore.quantity:0):0;
				if(nearbyQuantity===0){
					isAvailable=false;
				}
			}
		}
	}catch(e){
		console.error(e);
	}
	return isAvailable;
}

function shouldUseNearby(pickupDetails, data){
	let useNearby=false;
	try{
		let quantity = pickupDetails.store?pickupDetails.store.quantity:0;
		let nearbyQuantity = pickupDetails.nearbyStore?data.inventory.nearbyStore.quantity:0;
		useNearby = (quantity===0 && nearbyQuantity>0);
	}catch(e){
		console.error(e);
	}
	return useNearby;
}

function isOnlyInStore(data){
	let isOnlyInStore = false;
	try{
		let fulfillment = data.fulfillment?data.fulfillment:null;
		let storeInventory = data.inventory ? data.inventory.store:null;
		// if(fulfillment && fulfillment.isAssortedToLocalStore && !fulfillment.isPurchasableInLocalStore){
		// 	isOnlyInStore = true;
		// 	return isOnlyInStore;
		// }
		if(fulfillment && fulfillment.store && fulfillment.store.buyOnlinePickUpInStore){
			if(((fulfillment.store.buyOnlinePickUpInStore.isInventoryRestricted) && !(storeInventory && storeInventory.isInStock))
				|| (fulfillment.store.buyOnlinePickUpInStore.isStoreAssortmentRestricted)) {
				isOnlyInStore = true;
				return isOnlyInStore;
			}
		}
	}catch(e){
		console.error(e);
	}

	return isOnlyInStore;
}

function isInstantCheckoutEligible(data){
	let isEligible = false;
	try{
		if(
			data.inventory &&
			data.inventory.online &&
			data.inventory.online.isInStock
		){
			isEligible = true;
		}
		// function isInstantCheckoutEligible() {
		//   return !!(pip.features.instantCheckoutFeatureEnabled
		//     && isShipToHome()
		//     && isItemInventoryAvail()
		//     && userSessionValid()
		//     && isB2CCustomer()
		//   );
		// }
		// function isGuestInstantCheckoutEligible() {
		//   return !!(pip.features.instantCheckoutFeatureEnabled
		//     && isShipToHome()
		//     && isItemInventoryAvail()
		//     && isB2CCustomer()
		//   );
		// }



		// function isItemInventoryAvail() {
		//   return !!(pip
		//     && pip.inventory
		//     && pip.inventory.online
		//     && pip.inventory.online.isInStock)
		// }
		// function isShipToHome() {
		//   return !!(pip
		//     && pip.fulfillment
		//     && pip.fulfillment.shipping
		//     && pip.fulfillment.shipping.shipToHome);
		// }

		// function userSessionValid() {
		//   const hasUserID = pip.customer.hasUserID();
		//   const hasUserSession = pip.customer.hasUserSession();
		//   const isLoggedIn = pip.customer.isLoggedIn();
		//   const isTwoFactorAuth = pip.customer.isTwoFactorAuth();
		//   return (hasUserID && !hasUserSession && !isTwoFactorAuth) || (isLoggedIn && isTwoFactorAuth);
		// }

		// function isB2CCustomer() {
		// 	const customerCookie = cookieUtils.parseJWTCookie('THD_CUSTOMER');
		//   const customerType = customerCookie && customerCookie.c;
		//   return !(customerType === "B2B" || customerType === "B2X");
		// }
	}catch(e){
		console.error(e);
	}
	return isEligible;
}

let receievedICModel = false;
function getInstantCheckoutModel(model, setDetails){
	try{
		if(model.fulfillmentDetails.isInstantCheckoutEligible && !receievedICModel){
			receievedICModel = true;
			if(window.location.href.indexOf("local")>-1){
				setTimeout(()=>{
					model.fulfillmentDetails.instantCheckoutModel = getMockICModel();
					// console.log("getInstantCheckoutModel()", model.fulfillmentDetails.instantCheckoutModel);
					setDetails(model);
				}, 1000);
			}else{
				window.$.ajax({
					type: "GET",
					url: "/p/svcs/instantCheckoutModel",
					timeout: 10000,
					dataType: "json",
					cache: false
				}).then(resp=>{
					if(resp){
						resp = resp.instantCheckoutModel || resp;
						const icModel = {instantCheckoutModel: resp};
						model.fulfillmentDetails = {...model.fulfillmentDetails, ...icModel};
						setDetails({...model});
					}
				}, (error)=>{
					const icModel = {instantCheckoutModel: {displayOption: "SIGN_IN"}};
					model.fulfillmentDetails = {...model.fulfillmentDetails, ...icModel};
					setDetails({...model});
				});
			}
		}
	}catch(e){
		console.error(e);
	}
}

function getMockICModel(){
	return {
		displayOption:"IC",
		addressCity:"DALLAS",
		addressZipCode:"75238",
		xref:"8621",
		daCardBrand:"MC",
		displayCardBrand:"MC"
	};
}


let checkingForAisleBayInfo = false;
function getAisleBayInfo(model, setDetails) {
	try{
		if(
			model.pickupDetails
			&& !model.pickupDetails.aisle
			// && !checkingForAisleBayInfo
			&& window.pipModelRequest
		){
			if(window._aisleBay_cache){
				if(isDebugMode){console.log("\n....cached aisle & bay");}
				finishAisleBayDeferred(model, setDetails, window._aisleBay_cache)
			}else{
				checkingForAisleBayInfo = true;
				setTimeout(()=>{
					checkingForAisleBayInfo = false;
					if(window && window.pipModelRequest){
						window.pipModelRequest.then((pipModel)=>{
							try{
								if(pipModel && pipModel.primaryItemData && pipModel.primaryItemData.aisleBay) {
									if(isDebugMode){console.log("\n....deferred aisle & bay");}
									finishAisleBayDeferred(model, setDetails, pipModel.primaryItemData.aisleBay)
								}else if(window._aisleBay_cache){
									if(isDebugMode){console.log("\n....cached aisle & bay");}
									finishAisleBayDeferred(model, setDetails, window._aisleBay_cache)
								}
							}catch(e){
								console.error(e);
							}
						});
					}
				}, 2000);
			}
		}
	}catch(e){
		console.error(e);
	}
}

function finishAisleBayDeferred(model, setDetails, aisleBay){
	try{
		const aisle = aisleBay.aisle;
		const bay = aisleBay.bay;
		model.pickupDetails.aisle = aisle;
		model.pickupDetails.bay = bay;
		model.fulfillmentDetails.aisle = aisle;
		model.fulfillmentDetails.bay = bay;
		setDetails({...model});
		moveAisleBay();
		window._aisleBay_cache = aisleBay;
	}catch(e){
		console.error(e);
	}
}

function useCachedAisleBayBetweenSuperSkuClicks(){
	try{

	}catch(e){
		console.error(e);
	}
}

function isNonMajorAppliance(data={}){
	let isNMA = false;
	try{
		if(data.protectionPlan){
			isNMA = (data.protectionPlan.category==="Major Appliances");
		}

	}catch(e){
		console.error(e);
	}
	return isNMA;
}

function doesBossExclusionApplies(pip) {
    if (pip && pip.shippingExclusion &&
    	pip.shippingExclusion.bossExclusionLocations &&
        pip.customer && pip.customer.localStore !== null) {
          const localizedStoreState = pip.customer.localStore.statecode;
          const isLocalStoreAK = pip.shippingExclusion.bossExclusionLocations.indexOf("AK") !== -1 && localizedStoreState === "AK";
          const isLocalStoreHI = pip.shippingExclusion.bossExclusionLocations.indexOf("HI") !== -1 && localizedStoreState === "HI"
          return (isLocalStoreAK || isLocalStoreHI)
    }
}

function doesSthExclusionApplies(excludedStates, shippingState) {
    if (excludedStates && shippingState){
    	return (
    		excludedStates.includes(shippingState) &&
    		(shippingState === "AK" || shippingState === "HI")
    	);
    }
}

export default PipModelAdapter;
